"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = __importDefault(require("./context"));
var context_2 = __importDefault(require("../Map/context"));
function Marker(props) {
    var _a, _b, _c;
    var map = React.useContext(context_2.default).map;
    var marker = React.useMemo(function () {
        var $marker = new kakao.maps.Marker();
        return $marker;
    }, []);
    React.useEffect(function () {
        marker.setMap(map);
        return function () { return marker.setMap(null); };
    }, []);
    var listeners = React.useRef({});
    listeners.current.onClick = function onClick() {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    listeners.current.onRightClick = function onRightClick() {
        var _a;
        (_a = props.onRightClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    listeners.current.onMouseOver = function onMouseOver(e) {
        var _a;
        (_a = props.onMouseOver) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    listeners.current.onMouseOut = function onMouseOut(e) {
        var _a;
        (_a = props.onMouseOut) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    listeners.current.onDragStart = function onDragStart() {
        var _a;
        (_a = props.onDragStart) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    listeners.current.onDragEnd = function onDragEnd() {
        var _a;
        (_a = props.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: marker.getPosition().getLat(),
                lng: marker.getPosition().getLng(),
            },
        });
    };
    React.useEffect(function () {
        kakao.maps.event.addListener(marker, "click", listeners.current.onClick);
        kakao.maps.event.addListener(marker, "rightclick", listeners.current.onRightClick);
        kakao.maps.event.addListener(marker, "mouseover", listeners.current.onMouseOver);
        kakao.maps.event.addListener(marker, "mouseout", listeners.current.onMouseOut);
        kakao.maps.event.addListener(marker, "dragstart", listeners.current.onDragStart);
        kakao.maps.event.addListener(marker, "dragend", listeners.current.onDragEnd);
        return function () {
            kakao.maps.event.removeListener(marker, "click", listeners.current.onClick);
            kakao.maps.event.removeListener(marker, "rightclick", listeners.current.onRightClick);
            kakao.maps.event.removeListener(marker, "mouseover", listeners.current.onMouseOver);
            kakao.maps.event.removeListener(marker, "mouseout", listeners.current.onMouseOut);
            kakao.maps.event.removeListener(marker, "dragstart", listeners.current.onDragStart);
            kakao.maps.event.removeListener(marker, "dragend", listeners.current.onDragEnd);
        };
    }, []);
    React.useEffect(function () {
        var latlng = new kakao.maps.LatLng(props.position.lat, props.position.lng);
        marker.setPosition(latlng);
    }, [props.position.lat, props.position.lng]);
    React.useEffect(function () {
        marker.setClickable(props.clickable);
    }, [props.clickable]);
    React.useEffect(function () {
        marker.setDraggable(props.draggable);
    }, [props.draggable]);
    React.useEffect(function () {
        marker.setVisible(props.visible);
    }, [props.visible]);
    React.useEffect(function () {
        var _a;
        marker.setTitle((_a = props.title) !== null && _a !== void 0 ? _a : "");
    }, [props.title]);
    React.useEffect(function () {
        marker.setOpacity(props.opacity);
    }, [props.opacity]);
    React.useEffect(function () {
        marker.setRange(props.range);
    }, [props.range]);
    React.useEffect(function () {
        marker.setAltitude(props.altitude);
    }, [props.altitude]);
    React.useEffect(function () {
        marker.setZIndex(props.zIndex);
    }, [props.zIndex]);
    React.useEffect(function () {
        if (!props.image)
            return marker.setImage(null);
        var size = new kakao.maps.Size(props.image.size.width, props.image.size.height);
        var offset = props.image.options.offset ? new kakao.maps.Point(props.image.options.offset.x, props.image.options.offset.y) : undefined;
        var spriteOrigin = props.image.options.spriteOrigin ? new kakao.maps.Point(props.image.options.spriteOrigin.x, props.image.options.spriteOrigin.y) : undefined;
        var spriteSize = props.image.options.spriteSize ? new kakao.maps.Size(props.image.options.spriteSize.width, props.image.options.spriteSize.height) : undefined;
        var options = __assign(__assign({}, props.image.options), { offset: offset,
            spriteOrigin: spriteOrigin,
            spriteSize: spriteSize });
        var $markerImage = new kakao.maps.MarkerImage(props.image.src, size, options);
        marker.setImage($markerImage);
    }, [props.image, (_a = props.image) === null || _a === void 0 ? void 0 : _a.src, (_b = props.image) === null || _b === void 0 ? void 0 : _b.size.width, (_c = props.image) === null || _c === void 0 ? void 0 : _c.size.height]);
    return (React.createElement(context_1.default.Provider, { value: { marker: marker } }, props.children));
}
Marker.defaultProps = {
    opacity: 1,
    visible: true,
    range: 500,
    zIndex: 0,
    altitude: 2,
    clickable: true,
    draggable: false,
};
Marker.propTypes = {
    /** 맵에 표시될 좌표 */
    position: prop_types_1.default.shape({
        lat: prop_types_1.default.number.isRequired,
        lng: prop_types_1.default.number.isRequired,
    }).isRequired,
    /** 기본 마커 대신 사용할 이미지 */
    image: prop_types_1.default.shape({
        src: prop_types_1.default.string.isRequired,
        size: prop_types_1.default.shape({
            width: prop_types_1.default.number.isRequired,
            height: prop_types_1.default.number.isRequired,
        }).isRequired,
        options: prop_types_1.default.shape({
            alt: prop_types_1.default.string,
            coords: prop_types_1.default.string,
            shape: prop_types_1.default.string,
            offset: prop_types_1.default.shape({ x: prop_types_1.default.number.isRequired, y: prop_types_1.default.number.isRequired }),
            spriteOrigin: prop_types_1.default.shape({ x: prop_types_1.default.number.isRequired, y: prop_types_1.default.number.isRequired }),
            spriteSize: prop_types_1.default.shape({ width: prop_types_1.default.number.isRequired, height: prop_types_1.default.number.isRequired }),
        }).isRequired,
    }),
    /** 툴팁 */
    title: prop_types_1.default.string,
    /** 불투명도 ( 0 ~ 1 ) */
    opacity: prop_types_1.default.number,
    /** 드래그 가능 여부 */
    draggable: prop_types_1.default.bool,
    /** 클릭 가능 여부 */
    clickable: prop_types_1.default.bool,
    /** 노출 여부 */
    visible: prop_types_1.default.bool,
    /** z-index 속성 값 */
    zIndex: prop_types_1.default.number,
    /** 표시될 최대 거리 ( 로드맵 only ) */
    range: prop_types_1.default.number,
    /** 고도 ( 로드맵 only ) */
    altitude: prop_types_1.default.number,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onClick: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onRightClick: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDragStart: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onDragEnd: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseOver: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseOut: prop_types_1.default.func,
};
exports.default = Marker;
